import {getCategoryObject} from "../../utils/utility.service";
import '../../assets/styles/transactions/transactionPreviousItem.scss'
import React from "react";
import moment from "moment/moment";
import dayjs from "dayjs";

const TransactionPreviousItem = ({current, transaction, currency}) => {

    return (<div key={transaction.id}
    className={`transaction-previous-item-section ${transaction.id == current ? 'this-is-current' : ''}`}
    >
                    <div className="amount">
                        {
                            transaction.isExclude ?
                                <span className="amount-exclude" >{currency} {transaction.amount}</span> :
                                (transaction.transactionType == 0 ? <span>-{currency} {transaction.amount}</span> :
                                    <span className="amount-credit">{currency} {transaction.amount}</span>)
                        }
                    </div>
                    <div className="date"><span>{dayjs(transaction.paidOn).format('DD-MMM-YYYY')}</span></div>
                    <div className="important">{transaction.isImportant ? <span className="important-flag" /> : ''}
                    <span>{transaction.spendAt !== '' ? transaction.spendAt : transaction.note }</span>
                    </div>
                </div>)
}

export default TransactionPreviousItem;